import { createContext } from "react";

import { CategoryInterface } from "../../interfaces/Category.ts";

interface InfoInterface {
  logo: string;
  title: string;
  description: string;
  aboutUs: string;
}

interface WebInfoInterface {
  webInfo: InfoInterface;
  categorys: CategoryInterface[];
  options: any[];
  contents: HeaderItem[];
  searchQuery: String;
  setSearchQuery: (search: string) => void;
}

export interface HeaderItem {
  title: string;
  icon?: string;
  link: string;
}

const WebInfoContext = createContext<WebInfoInterface>({
  webInfo: { logo: "", title: "", description: "", aboutUs: "" },
  categorys: [],
  options: [],
  contents: [],
  searchQuery: "",
  setSearchQuery: () => {},
});

export default WebInfoContext;
